import { compose, withProps } from 'recompose'
import { InputText } from './index'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

// this can/should be used in conjunction with the "amount" validator
// being applied to the form field. It will prevent the user from submitting
// values like "42." (with trailing decimal). If we try to prevent trailing
// decimal in this fn, it will completely disable users ability to enter
// a decimal at all.
export const formatAmount = (value = '') => {
  const clean = (value.toString().match(/[\d.]+/g) || []).join('')
  const arr = clean.split('')
  // integer amounts should not have any leading zeros, but still allow 0 as a value
  arr.length > 1 && arr[0] === '0' && arr[1] !== '.' && arr.shift()
  // amounts less than 1 should have a leading zero
  // to make it more clear the value is not an integer.
  arr[0] === '.' && arr.splice(0, 0, '0')

  return arr.join('')
}

const enhance = compose(
  withProps({
    format: formatAmount,
  }),
  toReduxFormField('InputAmount'),
)

export default enhance(InputText)
